"use strict";

var pageRelationsPromise = function pageRelationsPromise() {
    return new Promise(function (t, o) {
      localforage.getItem("pageRelations").then(function (e) {
        null === e ? $.ajax({
          url: "/JSONFiles/pageRelation.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("pageRelations", e).then(function (e) {
              t(e);
            })["catch"](function (e) {
              o(e);
            });
          },
          error: function error(e, t, n) {
            o("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        o(e);
      });
    });
  },
  getSurahNamesPromise = (pageRelationsPromise(), function () {
    return new Promise(function (t, o) {
      localforage.getItem("surahNames").then(function (e) {
        null === e ? $.ajax({
          url: "/JSONFiles/surahNames.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("surahNames", e).then(function (e) {
              t(e);
            })["catch"](function (e) {
              o(e);
            });
          },
          error: function error(e, t, n) {
            o("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        o(e);
      });
    });
  }),
  getSurahNameImages_IndoPakPromise = (getSurahNamesPromise(), function () {
    return new Promise(function (t, o) {
      localforage.getItem("surahNameImages_IndoPak").then(function (e) {
        null === e ? $.ajax({
          url: "/JSONFiles/surahNameImages_IndoPak.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("surahNameImages_IndoPak", e).then(function (e) {
              t(e);
            })["catch"](function (e) {
              o(e);
            });
          },
          error: function error(e, t, n) {
            o("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        o(e);
      });
    });
  }),
  getTotalAyaatPromise = (getSurahNameImages_IndoPakPromise(), function () {
    return new Promise(function (t, o) {
      localforage.getItem("getTotalAyaatPromise").then(function (e) {
        null === e ? $.ajax({
          url: "/JSONFiles/totalAyaat.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("getTotalAyaatPromise", e).then(function (e) {
              t(e);
            })["catch"](function (e) {
              o(e);
            });
          },
          error: function error(e, t, n) {
            o("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        o(e);
      });
    });
  }),
  getTotalAyaatPromise2 = function getTotalAyaatPromise2() {
    return new Promise(function (t, o) {
      $.ajax({
        url: "/JSONFiles/totalAyaat.json",
        dataType: "json",
        cache: !0,
        success: function success(e) {
          t(e);
        },
        error: function error(e, t, n) {
          o(n);
        },
        complete: function complete() {}
      });
    });
  },
  paraRelationsPromise = (getTotalAyaatPromise(), function () {
    return new Promise(function (t, o) {
      localforage.getItem("paraRelations").then(function (e) {
        null === e ? $.ajax({
          url: "/JSONFiles/paraRelationWithAyat.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("paraRelations", e.paraRelationsWithAyats).then(function (e) {
              t(e);
            })["catch"](function (e) {
              o(e);
            });
          },
          error: function error(e, t, n) {
            o("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        o(e);
      });
    });
  }),
  counrtyCodeRelation = (paraRelationsPromise(), function () {
    return new Promise(function (t, o) {
      localforage.getItem("countryCodeRelation").then(function (e) {
        null === e ? $.ajax({
          url: "/JSONFiles/countryCode.json",
          dataType: "json",
          cache: !0,
          success: function success(e) {
            localforage.setItem("countryCodeRelation", e.countryCode).then(function (e) {
              t(e);
            })["catch"](function (e) {
              o(e);
            });
          },
          error: function error(e, t, n) {
            o("error");
          },
          complete: function complete() {}
        }) : t(e);
      })["catch"](function (e) {
        console.log(e), o(e);
      });
    });
  });
function juzClicked(m) {
  window.history.replaceState(null, document.title, "".concat("/read" == qmRoute ? "/read" : "", "/juz/") + m), previousJuz = selectedJuz;
  currentScript;
  pageRelationsPromise().then(function (e) {
    for (var t, n, o = 1, a = 1, c = 1, r = 1, i = "IndoPak" == currentScript ? e.pageRelationIndoPak : e.pageRelationUthmanic, u = 0; u < i.length; u++) {
      var s = !1;
      if (i[u][2] === parseInt(m) && "IndoPak" == currentScript ? (t = i[u][selectionOfScriptNo], n = t, a = i[u][0], i[u][3], o = i[u][1], c = i[u][4], r = i[u][8], s = !0) : i[u][3] === parseInt(m) && "Uthmanic" == currentScript && (a = i[u][0], i[u][3], o = i[u][1], c = 4 == i[u][3] ? (n = t = 62, 93) : 7 == i[u][3] ? (n = t = 121, 82) : 11 == i[u][3] ? (n = t = 201, 93) : 26 == i[u][3] ? (n = t = 502, 1) : (t = i[u][selectionOfScriptNo], n = t, i[u][4]), r = i[u][8], s = !0), 1 == s) break;
    }
    juzClickedNo = m, scrollSelections.getParahJuzzNames().then(function (e) {
      "IndoPak" == currentScript ? e.ParaName : e.JuzName;
      $(".b_juz").text("Juz " + m), previousJuzPara = n;
    }), scrollAllowed = !1, document.getElementById("container").innerHTML = "", scrollSelections.goToDefinedPage(t);
    var l = isPlaying;
    l && (document.getElementById("btnPlayAudio-Btn").style.display = "none", document.getElementById("btnPauseAudio-Btn").style.display = "none", document.getElementById("progressDiv1").style.display = "inline", sound.pause()), isPlayFromOutside = !0, setTimeout(function () {
      $(".qr0").removeClass("qr0_active"), $("#" + a + "-" + c).addClass("qr0_active"), $("#" + a + "-" + c + "-T").addClass("qr0_active");
    }, 500), sharingSura = a + "-" + c, setTimeout(function () {
      localforage.setItem("surah_ruku_url_audio", padLeadingZeros(a, 3) + "-" + padLeadingZeros(o, 2)).then(function (e) {
        localforage.setItem("ayaah_ruku_url_audio", r).then(function (e) {
          localforage.setItem("ayaah_in_surah", c).then(function (e) {
            localforage.setItem("ruko_no", o).then(function (e) {
              highlightedAyaah = void 0, currentAyaah = r, isPlayFromOutside = !1, l && (document.getElementById("progressDiv1").style.display = "none", document.getElementById("btnPlayAudio-Btn").style.display = "inline", document.getElementById("btnPauseAudio-Btn").style.display = "none", ayahClick());
            });
          });
        });
      })["catch"](function (e) {
        console.log(e);
      });
    }, 1e3);
  }), localforage.setItem("selectedJuzId", m).then(function (e) {})["catch"](function (e) {}), $("#juzModal").modal("hide");
}
counrtyCodeRelation();